

























import Component from "vue-class-component";
import Vue from "vue";

/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 */
@Component({})
export default class ConfirmationDialog extends Vue {
  loading: boolean = false;
  dialog: boolean = false;
  resolve!: (value: boolean | PromiseLike<boolean>) => void;
  reject!: (value: boolean | PromiseLike<boolean>) => void;
  message: string = "";
  title: string = "";
  options: Record<string, unknown> = {
    textStyle: "",
    color: "primary",
    width: 290,
    zIndex: 200
  };

  open(title: string, message: string, options: Record<string, unknown>): Promise<boolean> {
    this.dialog = true;
    this.title = title;
    this.message = message;
    this.options = Object.assign(this.options, options);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  agree(): void {
    this.loading = true;
    this.resolve(true);
  }

  cancel(): void {
    this.resolve(false);
    this.dialog = false;
  }

  close(): void {
    this.loading = false;
    this.dialog = false;
  }
}
